var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.currentRow ? _vm.$t("编辑") : _vm.$t("新增"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "roleFrom",
    attrs: {
      model: _vm.roleFrom,
      rules: _vm.roleRule,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      },
      hideRequiredMark: ""
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("角色名称"),
      hasFeedback: ""
    }
  }, [_c("a-input", {
    model: {
      value: _vm.roleFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.roleFrom, "name", $$v);
      },
      expression: "roleFrom.name"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };